import actions from './actions';

const {
  NOTIFICATIONS_READ_SUCCESS,
  NOTIFICATIONS_READ_ERR,
  NOTIFICATIONS_READ_BEGIN,

  NOTIFICATIONS_DELETE_BEGIN,
  NOTIFICATIONS_DELETE_SUCCESS,
  NOTIFICATIONS_DELETE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const deleteinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const NOTIFICATIONSReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case NOTIFICATIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case NOTIFICATIONS_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case NOTIFICATIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const NOTIFICATIONSDeleteReducer = (state = deleteinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case NOTIFICATIONS_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case NOTIFICATIONS_DELETE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case NOTIFICATIONS_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { NOTIFICATIONSDeleteReducer, NOTIFICATIONSReducer };
